import React from "react";
import Card from "../../components/Card/Card";
import { FaEnvelope, FaWhatsapp } from "react-icons/fa";
import "../../App.css";

function ReachOutPage() {
  return (
    <div className="container">
      <div className="card-wrapper">
        <main className="card-container">
          <Card
            icon={<FaEnvelope />}
            title="Email Campaign"
            description="Host email campaign, configure the email body and send emails to filtered users from DB"
            buttonLabel="Create"
            buttonHref="https://topline.speedstack.tech/email_campagion/"
          />
          <Card
            icon={<FaWhatsapp />}
            title="WhatsApp Campaign"
            description="WhatsApp campaign configured to send messages for campaigns like email"
            buttonLabel="Create"
            buttonHref="https://topline.speedstack.tech/whatsapp_campagion/"
          />
        </main>
      </div>
    </div>
  );
}

export default ReachOutPage;
